import React from 'react';
import Footer from '../components/global/footer';
import Header from '../components/global/header';

const AboutPage = ({ history }) => {
  const goHome = () => history.push('/');

  return (
    <div>
      <Header />
      <main className="about_main">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="about_page">
                <h1 className="title text-center">
                  <span className="about-title-icon" aria-hidden="true">🏥</span> Про сервіс «Лікарі 24/7»
                </h1>

                <div className="about-content">
                  <p className="about-edition">
                    Редакція для сторінки «Про нас» на{' '}
                    <a href="https://likari.in.ua" target="_blank" rel="noopener noreferrer">
                      likari.in.ua
                    </a>{' '}
                    • 14.09.2026
                  </p>

                  <div className="about-summary">
                    <span className="summary-icon" aria-hidden="true">💙</span> «Лікарі 24/7» — пацієнтський вебсервіс, технологічно та функціонально
                    пов’язаний з медичною інформаційною системою «Каштан».
                  </div>

                  <p>
                    Сервіс створений для зручної взаємодії пацієнтів із закладами охорони здоров’я,
                    які використовують МІС «Каштан».
                  </p>
                  <p>
                    За допомогою «Лікарі 24/7» користувач може знайти медичного працівника або
                    кабінет, переглянути доступний час прийому та здійснити онлайн-запис. Залежно від
                    функціональних можливостей конкретного закладу та доступних користувачу функцій
                    також можуть бути доступні перегляд попередніх записів, перегляд і скасування
                    майбутніх записів та сервісні повідомлення.
                  </p>

                  <section>
                    <h2><span className="section-icon" aria-hidden="true">🩺</span> Які заклади та лікарі доступні у сервісі</h2>
                    <p>
                      У «Лікарі 24/7» відображаються медичні працівники, кабінети та заклади охорони
                      здоров’я, які використовують МІС «Каштан».
                    </p>
                    <p>
                      Інформація про медичних працівників, місця надання послуг, доступні дати та час
                      прийому формується на підставі даних відповідних закладів охорони здоров’я.
                    </p>
                    <p>
                      Через «Лікарі 24/7» онлайн-запис доступний лише до медичних працівників і закладів
                      охорони здоров’я, які використовують МІС «Каштан».
                    </p>
                  </section>

                  <section>
                    <h2><span className="section-icon" aria-hidden="true">📅</span> Як працює онлайн-запис</h2>
                    <p>
                      Користувач обирає місто, заклад, медичного працівника або необхідний вид прийому,
                      переглядає доступний час та створює запис.
                    </p>
                    <p>
                      Для окремих видів прийому можуть застосовуватися додаткові умови, встановлені
                      відповідним закладом охорони здоров’я, зокрема наявність електронного направлення
                      або інших документів, необхідних для відповідного виду обслуговування.
                    </p>
                    <p>
                      Актуальність розкладу та доступність часу для запису залежать від інформації,
                      яку веде відповідний заклад охорони здоров’я.
                    </p>
                  </section>

                  <section>
                    <h2><span className="section-icon" aria-hidden="true">💻</span> МІС «Каштан»</h2>
                    <p>
                      МІС «Каштан» — медична інформаційна система, яка використовується закладами
                      охорони здоров’я для автоматизації їх роботи та взаємодії з електронною системою
                      охорони здоров’я.
                    </p>
                    <p>
                      Оператором МІС «Каштан» є ТОВ «СІЕТ ХОЛДІНГ». Товариство є розробником
                      програмного забезпечення МІС «Каштан» та здійснює його технічну підтримку.
                    </p>
                    <p>
                      «Лікарі 24/7» забезпечує пацієнтам доступ до окремих функцій, пов’язаних із
                      використанням закладами охорони здоров’я МІС «Каштан».
                    </p>
                  </section>

                  <section>
                    <h2><span className="section-icon" aria-hidden="true">🔗</span> «Лікарі 24/7» та ЕСОЗ</h2>
                    <p>
                      МІС «Каштан» підключена до центральної бази даних електронної системи охорони
                      здоров’я в межах передбаченої для МІС функціональності.
                    </p>
                    <p>«Лікарі 24/7» не є державним Кабінетом пацієнта ЕСОЗ.</p>
                    <p>
                      Обсяг інформації та функцій, доступних користувачу через «Лікарі 24/7»,
                      визначається функціональністю сервісу та даними, доступними в межах роботи
                      відповідних закладів охорони здоров’я з МІС «Каштан».
                    </p>
                  </section>

                  <section>
                    <h2><span className="section-icon" aria-hidden="true">🤝</span> Допомога та підтримка</h2>
                    <p>
                      Якщо у вас виникли питання щодо роботи «Лікарі 24/7», авторизації, відображення
                      інформації або онлайн-запису, зверніться до служби технічної підтримки.
                    </p>
                    <p>
                      E-mail:{' '}
                      <a href="mailto:info@ciet-holding.com">info@ciet-holding.com</a>
                    </p>
                    <p>
                      Для питань щодо медичної допомоги, графіка роботи, умов прийому, направлень або
                      медичних документів необхідно звертатися безпосередньо до відповідного закладу
                      охорони здоров’я.
                    </p>
                  </section>
                </div>

                <div className="link_to_home" onClick={goHome}>На головну</div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <style>{`
        .about-content {
          line-height: 1.6;
          margin-bottom: 2rem;
          font-size: 16px;
          color: #2c3e50;
        }

        .about-content section {
          margin-bottom: 2.5rem;
          padding: 1.5rem 1.75rem;
          background: linear-gradient(135deg, #ffffff 0%, #f7fbff 100%);
          border: 1px solid #e2edf5;
          border-radius: 8px;
          box-shadow: 0 4px 14px rgba(44, 62, 80, 0.06);
        }

        .about-title-icon,
        .section-icon,
        .summary-icon {
          display: inline-block;
          font-style: normal;
        }

        .about-title-icon {
          margin-right: 0.35rem;
        }

        .section-icon {
          margin-right: 0.45rem;
          font-size: 1.15em;
        }

        .about-content .about-edition {
          margin-bottom: 3rem;
          text-align: center;
          color: #34495e;
        }

        .about-summary {
          margin-bottom: 3rem;
          padding: 1rem 1.25rem;
          background: linear-gradient(135deg, #eef7ff 0%, #f4fbf8 100%);
          border-left: 4px solid #3498db;
          color: #2c3e50;
          border-radius: 0 8px 8px 0;
          box-shadow: 0 4px 12px rgba(52, 152, 219, 0.1);
        }

        .summary-icon {
          margin-right: 0.45rem;
        }

        .about-content h2 {
          font-size: 1.4rem;
          font-weight: 600;
          margin: 0 -0.25rem 1.5rem;
          color: #2c3e50;
          border-bottom: 2px solid #3498db;
          padding-bottom: 0.5rem;
        }

        .about-content p {
          margin-bottom: 1.2rem;
          text-align: justify;
          color: #2c3e50;
        }

        .about-content a {
          color: #3498db;
          text-decoration: none;
          font-weight: 500;
        }

        .about-content a:hover {
          color: #2980b9;
          text-decoration: underline;
        }

        .link_to_home {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          background-color: #3498db;
          color: white;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
          margin-top: 2rem;
          text-decoration: none;
        }

        .link_to_home:hover {
          background-color: #2980b9;
          box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          transform: translateY(-1px);
        }

        @media (max-width: 768px) {
          .about-content {
            font-size: 14px;
          }

          .about-content h2 {
            font-size: 1.2rem;
          }

          .about-content section {
            padding: 1.25rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage;
